import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { FilterProvider } from '../../context/FilterContext';

export default function AppLayout() {
  return (
    <FilterProvider>
      <div className="min-h-screen bg-ivory-100">
        <Sidebar />
        <div className="ml-64">
          <TopBar />
          <main className="p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </FilterProvider>
  );
}
